require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-disposable-121.json") })
        }
      }, "path---photos-disposable-121");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-disposable-121!./.cache/json/photos-disposable-121.json
// module id = 349
// module chunks = 231608221292675